import { render, staticRenderFns } from "./OpenAiLogo.vue?vue&type=template&id=947df9ba"
import script from "./OpenAiLogo.vue?vue&type=script&lang=js"
export * from "./OpenAiLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports